
(() => {
  'use strict';

  const DRAWER_ID = 't4s-filter-hidden';
  const BAR_CLASS = 'kalles-custom-filter-bar';

  function initCustomFilters() {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer || !drawer.querySelector('.t4s-facets__form')) return;

    // Avoid duplicate bars when Kalles updates content through AJAX.
    const section = drawer.closest('.shopify-section') ||
      document.querySelector('.t4s-main-collection-page')?.closest('.shopify-section') ||
      document;

    if (document.querySelector('.' + BAR_CLASS)) return;

    drawer.classList.add('kalles-filter-bottom-sheet');

    const facets = Array.from(drawer.querySelectorAll('.t4s-facet'))
      .filter((facet) => facet.querySelector('.t4s-facet-title'));

    if (!facets.length) return;

    const bar = document.createElement('nav');
    bar.className = BAR_CLASS;
    bar.setAttribute('aria-label', 'Product filters');

    
const allButton = document.createElement('button');
allButton.type = 'button';
allButton.dataset.kallesFilterTarget = 'all';
allButton.setAttribute('aria-label', 'All filters');

allButton.innerHTML = `
  <span class="kalles-filter-main-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="19" height="19"
      fill="none" stroke="currentColor" stroke-width="1.8"
      stroke-linecap="round" stroke-linejoin="round">
      <line x1="4" y1="6" x2="20" y2="6"></line>
      <circle cx="9" cy="6" r="2" fill="#FBFBFB"></circle>
      <line x1="4" y1="12" x2="20" y2="12"></line>
      <circle cx="15" cy="12" r="2" fill="#FBFBFB"></circle>
      <line x1="4" y1="18" x2="20" y2="18"></line>
      <circle cx="10" cy="18" r="2" fill="#FBFBFB"></circle>
    </svg>
  </span>
  <span>فلتر</span>
`;

bar.appendChild(allButton);


    facets.forEach((facet, index) => {
      const title = facet.querySelector('.t4s-facet-title');
      const button = document.createElement('button');
      const id = 'kalles-filter-facet-' + index;

      facet.dataset.kallesFilterFacet = id;
      facet.classList.add('kalles-filter-facet-hidden');

      
button.type = 'button';
button.dataset.kallesFilterTarget = id;

button.innerHTML = `
  <span class="kalles-filter-label"></span>
  <span class="kalles-filter-chevron" aria-hidden="true">
    <svg viewBox="0 0 12 12" width="13" height="13"
      fill="none" stroke="currentColor" stroke-width="1.5"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M3 4.5 6 7.5 9 4.5"></path>
    </svg>
  </span>
`;

button.querySelector('.kalles-filter-label').textContent =
  title.textContent.trim();

      const activeValues = facet.querySelectorAll(
        'li.is--selected, li.is--selected a, input:checked'
      ).length;

      if (activeValues > 0) {
        const count = document.createElement('span');
        count.className = 'kalles-filter-count';
        count.textContent = String(activeValues);
        button.appendChild(count);
      }

      bar.appendChild(button);
    });

    
const collectionArea = document.querySelector(
  '.t4s-main-collection-page, .t4s-main-collection-search'
);

if (collectionArea) {
  collectionArea.parentNode.insertBefore(bar, collectionArea);
} else {
  drawer.parentNode.insertBefore(bar, drawer);
}


    
function openDrawer(target) {
  facets.forEach((facet) => {
    const isCurrent =
      target === 'all' ||
      facet.dataset.kallesFilterFacet === target;

    facet.classList.toggle('kalles-filter-facet-current', isCurrent);
    facet.classList.toggle('kalles-filter-facet-hidden', !isCurrent);
  });

  const originalTrigger = document.querySelector(
    '.t4s-btn-filter[data-drawer-options]'
  );

  if (originalTrigger) {
    originalTrigger.click();
  } else {
    drawer.classList.add('is--open');
    drawer.setAttribute('aria-hidden', 'false');
  }
}


    bar.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-kalles-filter-target]');
      if (!button) return;

      openDrawer(button.dataset.kallesFilterTarget);
    });
  }

  
function boot() {
  initCustomFilters();

  let lastForm = document.querySelector(
    '#t4s-filter-hidden .t4s-facets__form'
  );

  const observer = new MutationObserver(() => {
    const currentForm = document.querySelector(
      '#t4s-filter-hidden .t4s-facets__form'
    );

    if (!currentForm || currentForm === lastForm) return;

    lastForm = currentForm;

    document.querySelectorAll('.kalles-custom-filter-bar')
      .forEach((bar) => bar.remove());

    initCustomFilters();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
